// extracted by mini-css-extract-plugin
export default {"panel":"GZOofzLg2L8TxPqwJbYh","tabbedPanel":"Jg9bRLaUlroLDPDWrvhx","verticalContent":"HuFNTpfQylsrVJL79Ltn"};